import redaxios from 'redaxios';

// src/common/objectToUrl/objectToUrl.ts
var objectToUrl = (args) => {
  return Object.entries(args).map(
    ([key, value]) => `${key}=${Array.isArray(value) ? encodeURIComponent(value.join(",")) : encodeURIComponent(value)}`
  ).join("&");
};

// src/istock/istock.constants.ts
var SPONSOR_TRACKER_NAME = "istock";
var SPONSOR_CDN_URL = "https://fps.cdnpk.net/sponsor/istock/";
var ISTOCK_DEFAULT_RESPONSE = {
  name: "iStock",
  page: 0,
  perPage: 0,
  total: 0,
  logo: {
    imageUrl: "",
    trackerClickCustom: "",
    url: ""
  },
  trackerImpCustom: "",
  results: []
};
var ISTOCK_API_IMG_URL_FREEPIK = "https://istock-cdn.cdnpk.net/freepik/images/creative";
var ISTOCK_API_IMG_URL_FLATICON = "https://istock-cdn.cdnpk.net/flaticon/images/creative";
var ISTOCK_API_VIDEO_URL = "https://spg.cdnpk.net/freepik/videos/creative";
var PLACEMENTS_IDS = {
  srp: 917949,
  idp: 917949,
  "404": 917949,
  "idp-video": 917949,
  "srp-video": 917949,
  popup: 917947,
  stockbanner: 917949
};

// src/istock/mock/index.ts
var mockTypeImportMapper = {
  default: "photo",
  video: "video",
  icon: "icon",
  ai: "ai"
};
var getMockImportKey = (phrase = "default", type) => {
  type = type ? type : "default";
  const mockTypes = Object.keys(mockTypeImportMapper);
  return phrase.includes("ai image") ? "ai" : mockTypes.includes(type) ? type : "default";
};
var getMockFromCdn = async ({
  type,
  phrase
}) => {
  const importPromise = mockTypeImportMapper[getMockImportKey(phrase, type)];
  const data = await redaxios.get(
    `${SPONSOR_CDN_URL}mock/data-${importPromise}-09-24.json`
  );
  data.data = {
    ...data.data,
    isDataMocked: true
  };
  return data.data;
};

// src/istock/api/istock.params.ts
var paramsToSend = (searchType, options, projectId) => {
  const { params } = options;
  const baseUrl = projectId === "www.freepik.com" ? ISTOCK_API_IMG_URL_FREEPIK : ISTOCK_API_IMG_URL_FLATICON;
  const paramsObject = {
    params: { phrase: params.phrase, page_size: 100 },
    baseUrl
  };
  if (searchType === "video") {
    return {
      ...paramsObject,
      baseUrl: ISTOCK_API_VIDEO_URL
    };
  }
  if (searchType === "icon" || searchType === "vector") {
    return {
      ...paramsObject,
      params: {
        ...paramsObject.params,
        graphical_styles: "vector"
      }
    };
  }
  return {
    ...paramsObject,
    params: {
      ...paramsObject.params,
      graphical_styles: "photography"
    }
  };
};

// src/istock/api/istock.api.ts
var supportedLanguageValues = {
  de: "de",
  en: "en-US",
  es: "es",
  fr: "fr",
  it: "it",
  ja: "ja",
  "pt-br": "pt-PT",
  pt: "pt-PT",
  ru: "ru"
};
var getIstock = async (options) => {
  const { baseUrl, params } = paramsToSend(
    options.type,
    options,
    options.projectId
  );
  try {
    const queryString = objectToUrl({
      fields: ["detail_set", "referral_destinations"],
      safe_search: true,
      sort_order: "most_popular",
      ...params,
      phrase: params.phrase || ""
    });
    const urlWithParams = `${baseUrl}?${queryString}`;
    const data = await fetch(urlWithParams, {
      method: "GET",
      headers: {
        "Accept-Language": supportedLanguageValues[options.params.language] || "en-US"
      }
    }).then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response;
    }).then((response) => response.json());
    if ("images" in data && data.images.length === 0 || "videos" in data && data.videos.length === 0) {
      throw new Error("No images or videos found");
    }
    const page = getPaginationWithMaxPage(options.params.page || 1);
    const pageRollover = Math.max(0, page - 1) % 10;
    if ("images" in data) {
      return {
        ...data,
        images: data.images.slice(pageRollover * 10, pageRollover * 10 + 10)
      };
    }
    return {
      ...data,
      videos: data.videos.slice(pageRollover * 10, pageRollover * 10 + 10)
    };
  } catch (error) {
    console.error("iStock API return an error", error);
    return getMockFromCdn({ type: options.type, phrase: "" });
  }
};
var getPaginationWithMaxPage = (page) => {
  const maxPage = 5;
  return page > maxPage ? page % 5 || 5 : page;
};

// src/istock/helpers/isIstockVideoTypeGuard.ts
var isIstockVideoTypeGuard = (item) => {
  return "clip_length" in item;
};

// src/istock/istock.tracker.ts
var getPlacement = (options) => {
  const { type: resourceType, placement } = options;
  const isVideo = resourceType === "video";
  if (isVideo && (placement === "idp" || placement === "srp")) {
    return `${placement}-video`;
  }
  return placement;
};
var sponsor = (options, url) => {
  const placement = getPlacement(options);
  const isMockedData = options.isMockedData;
  const args = {
    sharedId: isMockedData ? `${placement}-default` : placement
  };
  if (options.userId) {
    args.subId1 = options.userId;
  }
  const type = options.impression ? "i" : "c";
  if (options.params && options.params.phrase) {
    args.subId2 = options.params.phrase;
  }
  args.subId3 = options.projectId;
  if (url) {
    args.u = url;
  }
  const placementAdId = PLACEMENTS_IDS[placement];
  return `https://istockphoto.6q33.net/${type}/39422/${placementAdId}/4205?${objectToUrl(
    args
  )}`;
};
var custom = (config) => {
  const { options: optionsIstock, action, link, itemId, isMockedData } = config;
  const options = optionsIstock;
  const args = {
    action,
    sponsor_pixel: options.placement,
    sponsor: SPONSOR_TRACKER_NAME,
    country: options.country
  };
  if (options.test)
    args.test = options.test;
  if (options.params && options.params.phrase)
    args.term = options.params.phrase;
  if (options.categoryType)
    args.type = options.categoryType;
  if (options.popupOrigin)
    args.origin = options.popupOrigin;
  if (link)
    args.link = link;
  if (itemId)
    args.item_id = itemId;
  if (action === "imp")
    args.type = isMockedData ? "default" : "api";
  return objectToUrl(args);
};

// src/common/url/url.redirect.ts
var encodeBase64 = (url) => typeof window === "undefined" ? Buffer.from(url).toString("base64") : btoa(url);
var concatUserIdParam = (options, concatUserId = false) => concatUserId && options.userId ? `&client_id=${options.userId}` : "";
var redirectUrl = (options, url, concatUserId = false) => `${options.redirectAndBase64}${encodeBase64(url)}${concatUserIdParam(
  options,
  concatUserId
)}`;
var getRedirectUrl = (config) => {
  const { url, options, concatUserId } = config;
  if (!options.redirectAndBase64)
    return url;
  return redirectUrl(options, url, concatUserId);
};

// src/istock/istock.url.ts
var getLogoUrl = (options) => {
  const impactUrl = sponsor(options);
  return getRedirectUrl({
    url: impactUrl,
    options,
    concatUserId: false
  });
};
var getResourceUrl = (options, item) => {
  const url = item.referral_destinations.filter(
    (destination) => destination.site_name === "istockphoto" && destination
  )[0].uri;
  const impactUrl = sponsor(options, url);
  return getRedirectUrl({
    url: impactUrl,
    options,
    concatUserId: false
  });
};
var getShowMoreUrl = (options) => {
  const language = options.params && options.params.language || "en";
  const searchType = options.type;
  const query = options.params && options.params.query ? encodeURIComponent(options.params.query) : "";
  const urlShowMore = () => {
    if (searchType === "video") {
      return `https://www.istockphoto.com/${language}/search/2/film?family=creative&phrase=${query}`;
    }
    if (searchType === "icon" || searchType === "vector") {
      return `https://www.istockphoto.com/${language}/search/2/image?family=creative&mediatype=illustration&phrase=${query}`;
    }
    return `https://www.istockphoto.com/${language}/search/2/image?family=creative&phrase=${query}`;
  };
  const showMoreUrl = urlShowMore();
  const impactUrl = sponsor(options, showMoreUrl);
  return getRedirectUrl({
    url: impactUrl,
    options,
    concatUserId: false
  });
};
var getPromoUrl = (options) => {
  const language = options.locale.toLowerCase() || "en";
  const stockbannerUrl = `https://www.istockphoto.com/${language}/`;
  const partnerizeUrl = sponsor(options, stockbannerUrl);
  return getRedirectUrl({
    url: partnerizeUrl,
    options,
    concatUserId: true
  });
};

// src/istock/istock.mappers.ts
var timeToMilliseconds = (time) => {
  const [hours, minutes, seconds, milliseconds] = time.split(":");
  return parseInt(hours) * 60 * 60 * 1e3 + parseInt(minutes) * 60 * 1e3 + parseInt(seconds) * 1e3 + parseInt(milliseconds);
};
var mapResponseAPIToVM = (item, options) => {
  const isVideo = isIstockVideoTypeGuard(item);
  return {
    id: item.id,
    url: getResourceUrl(options, item),
    urlImage: item.display_sizes[1].uri,
    width: 170,
    height: 90,
    trackerClickCustom: custom({
      options,
      action: "clk",
      itemId: item.id
    }),
    ...isVideo && {
      urlVideoPreview: item.display_sizes[0].uri,
      videoPreviewHeight: 120,
      videoPreviewWidth: 249,
      // iStock duration is a string with format "HH:MM:SS:MS"
      duration: timeToMilliseconds(item.clip_length)
    }
  };
};
var mapResponseToVM = (response, options) => {
  const iStockResponse = "videos" in response ? response.videos : response.images;
  const isMockedData = response.isDataMocked || false;
  try {
    const couponInBanner404 = options.placement === 404 ? {
      coupon: {
        trackerClickCustom: custom({
          options,
          action: "clk",
          link: "promo"
        }),
        url: getLogoUrl(options)
      }
    } : {};
    return {
      name: "iStock",
      results: iStockResponse.map(
        (item) => mapResponseAPIToVM(item, options)
      ),
      coupon: {
        trackerClickCustom: custom({
          options,
          action: "clk",
          link: "promo"
        }),
        url: getShowMoreUrl(options)
      },
      logo: {
        imageUrl: "https://fps.cdnpk.net/fpsp/istock/logo.svg",
        trackerClickCustom: custom({
          options,
          action: "clk",
          link: "logo"
        }),
        url: getLogoUrl(options)
      },
      trackerImpCustom: custom({
        options,
        action: "imp",
        isMockedData
      }),
      trackerImpSponsor: sponsor({
        ...options,
        impression: true,
        isMockedData
      }),
      showMore: {
        trackerClickCustom: custom({
          options,
          action: "clk",
          link: "more"
        }),
        url: getShowMoreUrl(options)
      },
      ...couponInBanner404
    };
  } catch (error) {
    return ISTOCK_DEFAULT_RESPONSE;
  }
};

// src/istock/istock.banner.ts
var getIstockBanner = (options) => getIstock(options).then((data) => mapResponseToVM(data, options));

// src/istock/istock.popup.ts
var getIstockPopup = (options) => {
  return {
    trackerClickCustom: custom({
      options,
      action: "clk"
    }),
    url: getShowMoreUrl(options)
  };
};

// src/istock/istock.stockbanner.ts
var getIstockStockbanner = (options) => {
  const imageUrl = `${SPONSOR_CDN_URL}stockbanner/v2/${options.locale.toLocaleUpperCase()}.jpg`;
  return {
    imageUrl,
    trackerClickCustom: custom({
      options,
      action: "clk"
    }),
    trackerImpCustom: custom({
      options,
      action: "imp"
    }),
    trackerImpSponsor: sponsor({
      ...options,
      impression: true
    }),
    url: getPromoUrl(options)
  };
};

// src/istock/istock.initialize.ts
var getIstock2 = async (options) => {
  if (options.components === "stockbanner") {
    return await getIstockStockbanner(options);
  }
  if (options.components === "popup") {
    return await getIstockPopup(options);
  }
  return await getIstockBanner(options);
};

// src/istock/istock.vm.ts
var istock_vm_exports = {};

// src/shutterstock/mock/index.ts
var mockTypeImportMapper2 = {
  default: import('./data-freepik-6NI4PPJO.mjs').then((mod) => mod.default),
  video: import('./data-video-DEEUFBTR.mjs').then((mod) => mod.default),
  flaticon: import('./data-flaticon-V77XJBWI.mjs').then((mod) => mod.default)
};
var getMock = async ({ projectId, type }) => {
  const flaticonType = projectId.match(/flaticon/) ? "flaticon" : null;
  const mockTypes = Object.keys(mockTypeImportMapper2);
  const importPromise = mockTypeImportMapper2[flaticonType || (type && mockTypes.includes(type) ? type : "default") || "default"];
  const data = await importPromise;
  return data;
};

// src/shutterstock/shutterstock.constants.ts
var SPONSOR_TRACKER_NAME2 = "shutterstock";
var SPONSOR_CDN_URL2 = `https://fps.cdnpk.net/fpsp/${SPONSOR_TRACKER_NAME2}/`;
var SHUTTERSTOCK_DEFAULT_RESPONSE = {
  name: "Shutterstock",
  page: 0,
  perPage: 0,
  total: 0,
  logo: {
    imageUrl: "",
    trackerClickCustom: "",
    url: ""
  },
  trackerImpCustom: "",
  results: []
};
var CLIENT_SHUTTERSTOCK_API_KEY = "4unQvZHxwgWaJh7DqKGK06AaKqLy9ZJM";
var SHUTTERSTOCK_API_MIN_RESULTS = 8;
var CLIENT_SHUTTERSTOCK_API_IMG_URL = `https://sps.cdnpk.net/v2/images/search?api_key=${CLIENT_SHUTTERSTOCK_API_KEY}`;
var CLIENT_SHUTTERSTOCK_API_VIDEO_URL = `https://sps.cdnpk.net/v2/videos/search?api_key=${CLIENT_SHUTTERSTOCK_API_KEY}`;
var PLACEMENTS_IDS2 = {
  srp: 1906897,
  idp: 1906897,
  "404": 1906897,
  "idp-video": 1906902,
  "srp-video": 1906902,
  popup: 1906904,
  stockbanner: 1906896
};

// src/shutterstock/api/shutterstock.params.ts
var getShutterstockParams = (options) => {
  const { params, type } = options;
  let result = {
    ...params
  };
  const query = params && params.query;
  const hasExcludeQuery = query && /\s-[^ ]/g.test(query);
  if (hasExcludeQuery) {
    result = {
      ...result,
      query: query.replace(/\s-/g, " NOT ")
    };
  }
  if (type === "video") {
    result = {
      ...result,
      view: "full"
    };
  }
  return result;
};

// src/shutterstock/api/shutterstock.api.ts
var getShutterstock = async (options) => {
  const { projectId, type } = options;
  const shutterstockApiUrl = type === "video" ? CLIENT_SHUTTERSTOCK_API_VIDEO_URL : CLIENT_SHUTTERSTOCK_API_IMG_URL;
  try {
    const response = await redaxios.get(
      shutterstockApiUrl,
      {
        params: getShutterstockParams(options)
      }
    );
    if (response.data.data.length === 0) {
      return getMock({ projectId, type });
    }
    if (response.data.data.length < SHUTTERSTOCK_API_MIN_RESULTS) {
      const mock = await getMock({ projectId, type });
      const totalCount = response.data.total_count + mock.total_count;
      return {
        ...response.data,
        total_count: totalCount,
        data: [...response.data.data, ...mock.data]
      };
    }
    return response.data;
  } catch (error) {
    console.error("Shutterstock API return an error", error);
    return getMock({ projectId, type });
  }
};

// src/shutterstock/helpers/isShutterVideoTypeGuard.ts
var isShutterVideoTypeGuard = (item) => {
  return item.media_type === "video";
};

// src/shutterstock/shutterstock.tracker.ts
var getPlacement2 = (options) => {
  const { type: resourceType, placement } = options;
  const isVideo = resourceType === "video";
  if (isVideo && (placement === "idp" || placement === "srp")) {
    return `${placement}-video`;
  }
  return placement;
};
var sponsor2 = (options, url) => {
  const placement = getPlacement2(options);
  const args = {
    sharedId: options.projectId,
    subId1: placement
  };
  const type = options.impression ? "i" : "c";
  if (options.params && options.params.query) {
    args.subId2 = options.params.query;
  }
  if (options.userId)
    args.subId3 = options.userId;
  if (url)
    args.u = url;
  const placementAdId = PLACEMENTS_IDS2[placement];
  return `https://shutterstock.7eer.net/${type}/5159507/${placementAdId}/1305?${objectToUrl(
    args
  )}`;
};
var custom2 = (config) => {
  const { options: optionsShutterstock, action, link, itemId } = config;
  const options = optionsShutterstock;
  const args = {
    action,
    sponsor_pixel: options.placement,
    sponsor: SPONSOR_TRACKER_NAME2,
    country: options.country
  };
  if (options.test)
    args.test = options.test;
  if (options.params && options.params.query)
    args.term = options.params.query;
  if (options.categoryType)
    args.type = options.categoryType;
  if (options.popupOrigin)
    args.origin = options.popupOrigin;
  if (link)
    args.link = link;
  if (itemId)
    args.item_id = itemId;
  return objectToUrl(args);
};

// src/common/getParameterUrl/getParameterUrl.ts
var getParameterUrl = (url) => {
  const parsedUrl = new URL(url);
  const params = new URLSearchParams(parsedUrl.search);
  const uParam = params.get("u");
  return uParam !== null && uParam !== void 0 ? uParam : "";
};

// src/shutterstock/shutterstock.url.ts
var getLogoUrl2 = (options) => {
  const impactUrl = sponsor2(options);
  return getRedirectUrl({
    url: impactUrl,
    options,
    concatUserId: false
  });
};
var getResourceUrl2 = (options, item) => {
  const resourceUrl = getParameterUrl(item.affiliate_url);
  const impactUrl = sponsor2(options, resourceUrl);
  return getRedirectUrl({
    url: impactUrl,
    options,
    concatUserId: false
  });
};
var getShowMoreUrl2 = (options) => {
  const language = options.params && options.params.language || "en";
  const searchType = options.searchType ? `/${options.searchType}` : "";
  const query = options.params && options.params.query ? encodeURIComponent(options.params.query.replace(" ", "-")) : "";
  const imageType = options.params && options.params.image_type ? `?image_type=${options.params.image_type}` : "";
  const showMoreUrl = `https://www.shutterstock.com/${language}${searchType}/search/${query}${imageType}`;
  const impactUrl = sponsor2(options, showMoreUrl);
  return getRedirectUrl({
    url: impactUrl,
    options,
    concatUserId: false
  });
};
var getPromoUrl2 = (options) => {
  const language = options.locale.toLowerCase() || "en";
  const stockbannerUrl = `https://www.shutterstock.com/${language}/`;
  const partnerizeUrl = sponsor2(options, stockbannerUrl);
  return getRedirectUrl({
    url: partnerizeUrl,
    options,
    concatUserId: true
  });
};

// src/shutterstock/shutterstock.mappers.ts
var mapResponseAPIToVM2 = (item, options) => {
  const isVideo = isShutterVideoTypeGuard(item);
  return {
    id: item.id,
    url: getResourceUrl2(options, item),
    trackerClickCustom: custom2({
      options,
      action: "clk",
      itemId: item.id
    }),
    ...!isVideo && {
      type: item.image_type,
      urlImage: item.assets.huge_thumb.url,
      width: item.assets.huge_thumb.width,
      height: item.assets.huge_thumb.height
    },
    ...isVideo && {
      type: item.media_type,
      urlImage: item.assets.thumb_jpg.url,
      urlVideoPreview: item.assets.preview_mp4.url,
      videoPreviewHeight: item.assets.web.height,
      videoPreviewWidth: item.assets.web.width,
      // ShutterStock duration is in seconds so we need to convert it to milliseconds
      duration: item.duration * 1e3
    }
  };
};
var mapResponseToVM2 = (response, options) => {
  try {
    const couponInBanner404 = options.placement === 404 ? {
      coupon: {
        trackerClickCustom: custom2({
          options,
          action: "clk",
          link: "promo"
        }),
        url: getLogoUrl2(options)
      }
    } : {};
    return {
      name: "Shutterstock",
      results: response.data.map((item) => mapResponseAPIToVM2(item, options)),
      page: response.page,
      perPage: response.per_page,
      total: response.total_count,
      coupon: {
        trackerClickCustom: custom2({
          options,
          action: "clk",
          link: "promo"
        }),
        url: getShowMoreUrl2(options)
      },
      logo: {
        imageUrl: "https://fps.cdnpk.net/fpsp/shutterstock/logo.svg",
        trackerClickCustom: custom2({
          options,
          action: "clk",
          link: "logo"
        }),
        url: getLogoUrl2(options)
      },
      trackerImpCustom: custom2({ options, action: "imp" }),
      trackerImpSponsor: sponsor2({
        ...options,
        impression: true
      }),
      showMore: {
        trackerClickCustom: custom2({
          options,
          action: "clk",
          link: "more"
        }),
        url: getShowMoreUrl2(options)
      },
      ...couponInBanner404
    };
  } catch (error) {
    console.error(error);
    return SHUTTERSTOCK_DEFAULT_RESPONSE;
  }
};

// src/shutterstock/shutterstock.banner.ts
var getShutterstockBanner = (options) => getShutterstock(options).then((data) => mapResponseToVM2(data, options));

// src/shutterstock/shutterstock.popup.ts
var getShutterstockPopup = (options) => {
  return {
    trackerClickCustom: custom2({
      options,
      action: "clk"
    }),
    url: getShowMoreUrl2(options)
  };
};

// src/shutterstock/shutterstock.stockbanner.ts
var getShutterstockStockbanner = (options) => {
  const imageUrl = `${SPONSOR_CDN_URL2}stockbanner/${options.locale.toLocaleUpperCase()}.jpg`;
  return {
    imageUrl,
    trackerClickCustom: custom2({
      options,
      action: "clk"
    }),
    trackerImpCustom: custom2({
      options,
      action: "imp"
    }),
    trackerImpSponsor: sponsor2({
      ...options,
      impression: true
    }),
    url: getPromoUrl2(options)
  };
};

// src/shutterstock/shutterstock.initialize.ts
var getShutterstock2 = async (options) => {
  if (options.components === "stockbanner") {
    return await getShutterstockStockbanner(options);
  }
  if (options.components === "popup") {
    return await getShutterstockPopup(options);
  }
  return await getShutterstockBanner(options);
};

// src/shutterstock/shutterstock.vm.ts
var shutterstock_vm_exports = {};

// src/common/tracker/tracker.vm.ts
var tracker_vm_exports = {};

// src/istock/api/istock.api.model.ts
var istock_api_model_exports = {};

// src/shutterstock/api/shutterstock.api.model.ts
var shutterstock_api_model_exports = {};

// src/index.ts
var Shutterstock = (options) => getShutterstock2(options);
var Istock = (options) => getIstock2(options);

export { Istock, istock_api_model_exports as IstockAPIOptions, istock_vm_exports as IstockVM, Shutterstock, shutterstock_api_model_exports as ShutterstockAPIOptions, shutterstock_vm_exports as ShutterstockVM, tracker_vm_exports as Tracker };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map